<div class="content-cup-collabTask" [class.buttonsVisible]="groupId && !isTeacher && !analytics?.completedOnce && !isClassExpired" #contentContainer>
    <h1 class="collaborative-skill-header d-flex justify-content-center align-items-center" [ngClass]="{'mb-0': !groupId || isGroupArchived}">
        <span *ngIf="groupId;else placeholderTitle">{{groupDetails.title}}</span>
        <ng-template #placeholderTitle>
            <span>{{'SHARED.COLLAB.TITLE'  | translate }}</span>
        </ng-template>
        <a qid="collab-group-info" class="d-flex align-items-center" href="javascript:void(0)" data-toggle="modal" data-target="#GroupInfoModal" [attr.aria-label]="'SHARED.COLLAB.SCREEN_READER.GROUP_INFO' | translate">
            <i class="nemo-font nemo-info info-icon" aria-hidden="true"></i>
        </a>
    </h1>
    <div class="archiveGroupInfo-wrapper" *ngIf="isGroupArchived">
        <p class="archiveGroupInfo d-flex">
            <i class="nemo-font nemo-info info-icon" aria-hidden="true"></i>
            <span>{{ isTeacher? ('SHARED.COLLAB.ARCHIVED_SUBMITTED_LOCK_VERSION_MSG' | translate) : ( groupId ? ('SHARED.COLLAB.ARCHIVED_SUBMITTED_LOCK_VERSION_MSG' | translate): ('SHARED.COLLAB.ARCHIVED_LOCK_VERSION_MSG' | translate))}}</span>
        </p>
    </div>
    <div class="row-wrapper">
        <div class="row" *ngIf="!groupId && !isGroupArchived">
            <div class="col-12 col-md-12 col-xl-8 offset-xl-2">
                <div class="d-sm-flex mb-3 disableGroupInfo-wrapper">
                    <div class="d-flex">
                        <i class="nemo-font nemo-info mt-1" aria-hidden="true"></i>
                        <span>{{'SHARED.COLLAB.DISABLE_GROUP_INFO_MSG' | translate }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
                <div class="col-12 col-md-8 offset-md-2" [ngClass]="{'col-xl-6 offset-xl-3': !(collabTask.prompt && collabTask.prompt.type==='image'),'lockedComment': isGroupArchived}">
                    <p class="mb-0 py-1 py-md-3 text-center">
                        <a qid="collab-instruction-view" href="javascript:void(0)" class="hide-control" (click)="hiddenInst=!hiddenInst">
                            <span *ngIf="hiddenInst;else Insvisible">{{ 'SHARED.COLLAB.SHOW_INSTRUCTION' | translate }}</span>
                            <ng-template #Insvisible>
                                <span>{{'SHARED.COLLAB.HIDE_INSTRUCTIONS' | translate }}</span>
                            </ng-template>
                            <i class="fa ml-2" [ngClass]="{'fa-eye':hiddenInst,'fa-eye-slash':!hiddenInst}" aria-hidden="true"></i>
                        </a>
                    </p>
                    <activity-question *ngIf="!hiddenInst" [contentType]="'cup-collab-task'" [activityInfo]="collabTask" [productMeta]="productMeta"></activity-question>
                    <div class="mb-3" [hidden]="!(collabTask.submissionType.id=='group-commenting')" class="comments-container">
                        <ng-template #commentsLoader>
                            <div *ngIf="showCommentsLoader" class="comments-loader">

                                <span class="mr-2">{{'SHARED.COLLAB.LOADING_COMMENTS' | translate }}</span>
                                <svg aria-hidden="true" class="fa-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="02" transform="translate(-207.000000, -328.000000)" fill="#0A1F44" fill-rule="nonzero">
                                            <g id="Group-10" transform="translate(138.000000, 320.000000)">
                                                <g id="Spinner" transform="translate(69.000000, 8.000000)">
                                                    <rect id="Rectangle-1" transform="translate(14.000000, 8.000000) rotate(90.000000) translate(-14.000000, -8.000000) " x="13" y="6" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-Copy-1" opacity="0.55" transform="translate(2.000000, 8.000000) rotate(90.000000) translate(-2.000000, -8.000000) " x="1" y="6" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-2" opacity="0.75" x="7" y="0" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-Copy-2" opacity="0.25" x="7" y="12" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-3" opacity="0.13" transform="translate(12.240000, 12.241320) rotate(135.000000) translate(-12.240000, -12.241320) " x="11.2399998" y="10.2413198" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-Copy-3" opacity="0.63" transform="translate(3.757359, 3.757359) rotate(135.000000) translate(-3.757359, -3.757359) " x="2.75735856" y="1.757359" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-4" opacity="0.87" transform="translate(12.242641, 3.757359) rotate(45.000000) translate(-12.242641, -3.757359) " x="11.2426406" y="1.75735901" width="2" height="4" rx="1"/>
                                                    <rect id="Rectangle-Copy-4" opacity="0.37" transform="translate(3.757359, 12.242641) rotate(45.000000) translate(-3.757359, -12.242641) " x="2.75735943" y="10.242641" width="2" height="4" rx="1"/>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </ng-template>
                        <div *ngIf="commentsData?.results?.length === 0" class="no-comments-wrapper py-3">
                            {{'SHARED.COLLAB.NO_COMMENTS_LABEL' | translate }}
                        </div>
                        <div *ngIf="commentsData?.results?.length > 0" class="comments-wrapper">
                            <div *ngIf="(commentsData?.next && !showCommentsLoader); else commentsLoader" class="load-more-comments">
                                <a href="javascript:void(0)" (click)="loadOldComments()" qid="load-previous-comments-btn">
                                    {{'SHARED.COLLAB.LOAD_MORE_COMMENTS' | translate }}<i class="fa fa-angle-up" aria-hidden="true"></i>
                                </a>
                            </div>
                            <!-- Need to remove highlighting from the comment when user hovers mouse or clicks on the comment -->
                            <div *ngFor="let comment of commentsData?.results" class="comment-card my-2 my-md-3 p-3"
                                    [attr.id]="'comment-' + comment.id"
                                    [class.highlight-card]="comment?.highlightComment ? true : false"
                                    (click)="comment?.highlightComment ? (comment.highlightComment = false) : ''"
                                    (mouseover)="comment?.highlightComment ? (comment.highlightComment = false) : ''">
                                <div class="comment-card-header row no-gutters">
                                    <div *ngIf="comment?.actor as actor" class="card-actor col-7 col-md-9 d-flex align-items-center"
                                                [class.teacher-actor]="!actor?.error && actor?.role !== 'student'">
                                        <ng-container *ngIf="!actor.error">
                                            <span class="actor-name">{{ actor?.name }}</span>
                                            <span *ngIf="actor?.role !== 'student'"
                                                    class="actor-role ml-2">{{'SHARED.COLLAB.ACTOR_TEACHER_LABEL' | translate }}</span>
                                        </ng-container>
                                    </div>
                                    <div class="card-time col-5 col-md-3">
                                        {{ comment?.elapsedTime }}
                                    </div>
                                </div>
                                <div class="comment-card-body quill-content" [innerHtml]="comment?.comment"></div>
                            </div>
                        </div>
                        <div class="user-comment-wrapper">
                            <div class="text-box-label mb-2">
                                {{'SHARED.COLLAB.YOUR_COMMENT_LABEL' | translate }}
                            </div>
                            <text-editor [activityName]="collabTask?.title" [contentType]="'cup-collab-task'"
                                  [textEditorDisable]="!groupId || isGroupArchived" (textSubmit)="postComment($event)">
                            </text-editor>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    <!-- Scroll Button Wrapper -->
    <div class="scroll-wrapper" [ngClass]="{'upArrow': scrollUp, 'buttonsVisible': ((groupId && !analytics?.completedOnce && !isClassExpired && !isTeacher) || ((analytics?.completedOnce || isTeacher) && !isLastActivity))}">
        <a *ngIf="scrollControlVisible" qid="collab-scroll-btn" href="javascript:void(0)" (click)="scrollThePage()" class="circle">
          <div class = "arrow-circle">
            <span class="sr-only">{{('SHARED.COLLAB.SCREEN_READER.SCROLL_BTN_' + (scrollUp ? 'UP' : 'DOWN' )) | translate}}</span>
            <!-- Arrow SVG -->
            <svg aria-hidden="true" [class.fa-rotate-180]="!scrollUp" width="19px" height="19px" viewBox="0 0 19 19"
                  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <path d="M11.0017689,0 C11.5540536,0 12.0017689,0.44771525 12.0017689,1 L12.0017689,9.998 C12.0017689,10.5502847 11.5540536,10.998 11.0017689,10.998 C10.4494841,10.998 10.0017689,10.5502847 10.0017689,9.998 L10.001,3.463 L1.70710678,11.7572083 C1.31658249,12.1477326 0.683417511,12.1477326 0.292893219,11.7572083 C-0.0976310729,11.366684 -0.0976310729,10.733519 0.292893219,10.3429947 L8.634,2 L2,2 C1.44771525,2 1,1.55228475 1,1 C1,0.44771525 1.44771525,0 2,0 L11.0017689,0 Z" id="path-18"></path>
                </defs>
                <g id="UI-5333-Collab-Tools-Sec---Comments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop-4" transform="translate(-1251.000000, -1571.000000)">
                        <g id="Group-13-Copy" transform="translate(1240.000000, 1561.000000)">
                            <g id="02_Icons/close-transcript" transform="translate(20.353553, 19.646447) scale(1, -1) rotate(-45.000000) translate(-20.353553, -19.646447) translate(14.353553, 13.146447)">
                                <mask id="mask-2" fill="white">
                                    <use xlink:href="#path-18"></use>
                                </mask>
                                <use id="Path-2" fill="#FFFFFF" transform="translate(6.000884, 6.025051) scale(-1, -1) translate(-6.000884, -6.025051) " xlink:href="#path-18"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        </a>
    </div>

    <!-- Submit button confirmation modal start -->
    <div class="modal fade submitionConfirmationModal" tabindex="-1" role="dialog" id="submitionConfirmation" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="mb-2"> {{ 'SHARED.COLLAB.NO_FURTHER_CHANGES_ALLOWED_MESSAGE' | translate }}</p>
                </div>
                <div class="modal-footer">
                    <button class="btn" qid="collab-group-info-confirm-cancel" id="collabTask-cancel-btn" data-dismiss="modal" #closecollabConfirmationModalBtn [ngClass]="{'disabled': showSubmitLoader}">{{ 'SHARED.COLLAB.CANCEL' | translate }}</button>
                    <button class="btn btn-submit" qid="collab-group-info-confirm-submit" id="collabTask-submit-btn" (click)="submitCollabActivity()" [ngClass]="{'disabled': showSubmitLoader}">
                        {{ 'SHARED.COLLAB.COMPLETE' | translate }}
                        <i class="fa fa-spinner fa-spin" *ngIf="showSubmitLoader" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Submit button confirmation modal end -->

    <!-- Changes not saved modal start-->
    <button class="btn" [hidden]="true" data-toggle="modal" data-target="#changesNotSavedModal" #showErrorModalBtn>Show Error</button>
    <changes-not-saved [activityType]="'cup-collab-task'" [errorType]="errorType"></changes-not-saved>
    <!-- Changes not saved modal end-->
</div>
<div *ngIf="groupId && !isTeacher && !analytics?.completedOnce && !isClassExpired" class="buttons-container">
    <button qid="collab-ready-btn" class="btn" id="ready-collabTask-btn" data-toggle="modal"
          [class.disabled]="!(commentsData?.results?.length > 0)" [tabIndex]="!(commentsData?.results?.length > 0) ? -1 : 0"
          [attr.data-target]="!(commentsData?.results?.length > 0) ? '' : '#submitionConfirmation'" >
        {{ 'SHARED.COLLAB.READY' | translate }}
    </button>
</div>

<div class="modal fade GroupInfoModal" tabindex="-1" role="dialog" id="GroupInfoModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header border-0 p-2">
                <button qid="collab-group-info-close" class="close" data-dismiss="modal" type="button" [attr.aria-label]="'SHARED.COLLAB.SCREEN_READER.CLOSE_GROUP_INFO' | translate">×</button>
                <span class="modal-title" *ngIf="groupId">
                    <i aria-hidden="true" class="nemo-font nemo-group-marking-queue"></i>
                    {{groupDetails?.title}}
                </span>
            </div>
            <div *ngIf="groupId;else placeholderModal" class="modal-body mb-5">
                <p *ngFor="let member of groupMembers">
                    {{member}}
                </p>
            </div>
            <ng-template #placeholderModal>
                <div class="modal-body mt-3 mb-5 text-center">
                    <p>{{'SHARED.COLLAB.MODAL_PLACEHOLDER' | translate }}</p>
                </div>
            </ng-template>
        </div>
    </div>
</div>
